<script setup>
// 菜单模式 顶部导航
import { defineProps, defineEmits } from 'vue'
defineProps({
  menuList: {
    type: Array,
    default: () => []
  },
  menuInfo: {
    type: Object,
    default: () => {}
  },
  themeColor: {
    type: String,
    default: '#409eff'
  },
  activeMenu: {
    type: Number,
    default: 0
  }
})

const emit = defineEmits(['topMenuClick'])

const topMenuClick = (item) => {
  emit('topMenuClick', item)
}
</script> 

<template>
  <div class="top-menu" v-if="menuInfo.position === 'top'" :style="{ justifyContent:menuInfo.topPos, '--themeColor': themeColor, '--JustifyContent': menuInfo.topPos }">
    <template v-if="menuInfo.topStyle === 'one' || menuInfo.topStyle === undefined">
      <el-scrollbar class="topnav-1">
        <template v-for="(topNav, index) in menuList">
          <div @click="topMenuClick(topNav)" :style="topNav.fontStyle"  class="topnav-1-item" :class="activeMenu === topNav.id ? 'topnav-1-active' : ''" :key="index" v-if="topNav.isAppenCol || topNav.isAppenCol === undefined">
            {{ topNav.name }}
          </div>
        </template>
      </el-scrollbar>
    </template>
    <template v-else-if="menuInfo.topStyle === 'two'">
      <el-scrollbar class="topnav-2">
        <template v-for="topNav in menuList">
          <div class="topnav-2-item" :style="topNav.fontStyle" v-if="topNav.isAppenCol || topNav.isAppenCol === undefined" @click="topMenuClick(topNav)" :key="topNav.id" :class="activeMenu === topNav.id ? 'topnav-2-active' : ''">{{topNav.name}}</div>
        </template>
      </el-scrollbar>
    </template>
    <template v-else-if="menuInfo.topStyle === 'three'">
      <div class="topnav-3">
        <template v-for="topNav in menuList">
          <div class="topnav-3-item" :style="topNav.fontStyle" v-if="topNav.isAppenCol || topNav.isAppenCol === undefined" @click="topMenuClick(topNav)" :key="topNav.id" :class="activeMenu === topNav.id ? 'topnav-3-active' : ''">{{topNav.name}}</div>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped lang='scss'>
$themeColor: var(--themeColor);
$justifyContent: var(--JustifyContent);
.top-menu {
  display: flex;
  box-sizing: border-box;
  border-bottom: solid 1px #ccc;
  padding: 6px 20px;
  background: #fff;
  width: 100%;
  &-item {
    padding: 5px 10px;
    background: rgba(75, 75, 75, 0.1);
    margin-right: 20px;
    font-size: 12px;
    color: #333;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
  }
  &-active {
    background: rgba(78, 166, 255, 0.1);
    color: $themeColor;
  }
}

.el-scrollbar {
  width: 100%;
}

::v-deep .topnav-1 {
  .el-scrollbar__wrap {
    overflow-x: hidden;
    display: flex;
    justify-content: $justifyContent;
  }
  .el-scrollbar__view {
    border-radius: 8px;
    padding: 3px 10px 0 10px;
    height: 100%;
    box-sizing: border-box;
    background-color: #F1F1F1;
    display: flex;
    width: fit-content;
    margin-bottom: -3px;
  }
  &-item {
    padding: 10px 16px;
    color: #000000;
    font-weight: 400;
    font-size: 16px;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 10px 0 0;
    position: relative;
    cursor: pointer;
  }
  &-active {
    background-color: #fff;
    color: $themeColor !important;
    &::after, &::before {
      content: '';
      width: 10px;
      height: 10px;
      position: absolute;
      bottom: 0;
    }
    &::after {
      left: -10px;
      background: radial-gradient(circle at 0 0, transparent 10px, #fff 10px);
    }
    &::before {
      right: -10px;
      background: radial-gradient(circle at 100% 0, transparent 10px, #fff 10px);
    }
  }
}

::v-deep .topnav-2 {
  border-radius: 90px;
  .el-scrollbar__wrap {
    display: flex;
    justify-content: $justifyContent;
  }
  .el-scrollbar__view {
    border-radius: 90px;
    padding: 5px 0;
    display: flex;
    background-color: #F1F1F1;
    align-items: center;
    width: fit-content;
  }
  &-item {
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: #000000;
    font-weight: 400;
    position: relative;
    z-index: 0;
    height: fit-content;
    cursor: pointer;
    min-width: 172px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &-active {
    color: #000000 !important;
    &::after {
      content: '';
      background-color: #fff;
      width: calc(100% - 10px);
      height: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      z-index: -1;
      border-radius: 90px;
    }
  }
}

::v-deep .topnav-3 {
  display: flex;
  align-items: center;
  &-item {
    padding: 10px 45px;
    background-color: #F5F6F8;
    color: #51536D;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    box-sizing: border-box;
    -webkit-clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 52%, 0% 0%);
    clip-path: polygon(90% 0, 100% 50%, 90% 100%, 0% 100%, 10% 52%, 0% 0%);
    border-radius: 4px;
    cursor: pointer;
    &:first-of-type {
      -webkit-clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
      clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
    }
    &:last-of-type {
      -webkit-clip-path: polygon(0 0, 100% 1%, 100% 100%, 0 100%, 10% 50%);
      clip-path: polygon(0 0, 100% 1%, 100% 100%, 0 100%, 10% 50%);
    }

  } 
  &-active {
    color: #fff !important;
    background-color: $themeColor !important;
  }
}
</style>
